import React from "react"
import classes from "./pagiatino.module.css"

const Pagination = ({ postsPerPage, totalPosts, paginate, opacityChange }) => {
  const pageNumbers = []
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i)
  }
  const pagenationClick = number => {
    paginate(number)
  }
  return (
    <div className={classes.pageNation}>
      <ul className="action">
        {pageNumbers.map(number => (
          <li key={number}>
            <button
              type="button"
              className="button primary"
              onClick={() => pagenationClick(number)}
            >
              {number}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
export default Pagination
